import { TDevice } from '@cian/utils';

export const getSiteType = (deviceType: TDevice) => {
  return deviceType === 'phone' ? 'mobile' : deviceType;
};
